import BaseModal from '@c/modals/BaseModal';
import { XIcon } from 'lucide-react';
import { PublicUserDocument } from 'models/user';
import Image from 'next/image';

type SellerPictureModalProps = {
  user: PublicUserDocument;
  open: boolean;
  dismiss: () => void;
};

export default function SellerPictureModal({
  user,
  open,
  dismiss,
}: SellerPictureModalProps) {
  return (
    <BaseModal isOpen={open} dismiss={dismiss} bgTransparent hideCloseIcon>
      <div className="flex flex-col gap-y-6 p-4">
        <div className="flex w-full items-center justify-between p-4">
          <h1 className="text-[2.1rem] font-semibold text-white">
            {user.username}'s Profile Picture
          </h1>

          <button type="button" aria-label="Close modal" onClick={dismiss}>
            <XIcon className="h-10 w-10 text-white" />
          </button>
        </div>
        <div className="flex h-fit w-[40rem] items-center justify-center">
          <Image
            src={user.photo}
            alt={user.username}
            width={200}
            height={200}
            className="h-full w-full rounded-[2rem] object-contain"
          />
        </div>
      </div>
    </BaseModal>
  );
}
